import React from "react";

import "react-contexify/dist/ReactContexify.css";

import { useEffect, useRef, useState } from "react";

import { ServerInterface } from "../../ServerInterface";

export function OneMember(props: { memberId: string; memberFirstname: string; memberName: string }) {
  const { memberId, memberName, memberFirstname } = props;

  const src = `${ServerInterface.serverUrl}/booking/profileImage/?memberId=${memberId}`;

  const [imageNotFound, setImageNotFound] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", padding: "2px", minWidth: "9vw", zIndex: "1" }}>
      <img
        alt=""
        crossOrigin="anonymous"
        key={`f-${imageNotFound}`}
        src={imageNotFound ? "images/gost.png" : src}
        style={{
          width: "60px",
          height: "60px",
          borderRadius: "30px",
          objectFit: "cover",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.75)",
          marginRight: "10px",
          opacity: imageNotFound ? 0.3 : 1,
        }}
        onError={(ex) => {
          console.error("profileImage", ex);
          setImageNotFound(true);
        }}
      />

      <div style={{ lineHeight: "1em", textAlign: "left", fontSize: "0.9em" }}>
        {memberFirstname} <br /> <span style={{ color: "#666", fontSize: "0.8em" }}>{memberName}</span>
      </div>
    </div>
  );
}

export default function WelcomeOneRect(props: { booking: any; firstOneWithThisTime: boolean; statusColor: string; sitztAufDerTerrasse: boolean }) {
  var { booking, firstOneWithThisTime, statusColor, sitztAufDerTerrasse } = props;

  const elmRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (elmRef.current) {
      const textOuter = elmRef.current.querySelector("#textOuter");
      if (textOuter) {
        const textInner = elmRef.current.querySelector("#textInner");
        if (textInner) {
          const f = Math.min(1, (textOuter.clientWidth - 10) / textInner.clientWidth);
          (textInner as any).style.transform = `scale(${f})`;
        }
      }
    }
  });

  ////////////////////////////////////////////////////////////////////////////

  const elmLines: any = [];

  for (var p in booking.partners) {
    var partner = booking.partners[p];
    var partnerName: string = partner.split(";")[1];
    if (partnerName) {
      const memberFirstname = partnerName.split(" ")[0];
      partnerName = partnerName.substring(memberFirstname.length).trim();
      elmLines.push(<OneMember memberId={partner.split(";")[0]} memberFirstname={memberFirstname} memberName={partnerName} />);
    }
  }

  //
  // return RenderResult
  //

  const court = booking.court;
  const date = new Date(booking.date);

  return (
    <div
      ref={elmRef}
      key={booking.id}
      className="oneRect"
      style={{
        position: "relative",
        display: "block",
        width: "33%",
        //        height: "100%",
        overflow: "hidden",
        marginBottom: "20px",
      }}
    >
      <div
        key="textOuter"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          whiteSpace: "nowrap",
          height: "100%",
        }}
      >
        {!sitztAufDerTerrasse && (
          <div
            style={{
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              right: "5px",
              top: "1px",
              borderRadius: "20px",
              width: "30px",
              height: "30px",
              backgroundColor: "green",
              color: "white",
            }}
          >
            <b>{court}</b>
          </div>
        )}

        <div style={{ padding: "5px", display: "flex", flexDirection: "column" }}> {elmLines}</div>
      </div>
    </div>
  );
}
